module.exports = __webpack_public_path__ + "static/img/avatar-default.f1f5dc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/avatar-default.svg
// module id = 2263
// module chunks = 1